<!--
 * @Descripttion: 
 * @version: 
 * @Author: geory
 * @Date: 2023-08-14 17:08:47
 * @LastEditors: geory
 * @LastEditTime: 2026-07-31 14:58:06
-->
<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    //在页面加载时读取sessionStorage里的状态信息
    /*if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem("store"))))
    }*/
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    /*window.addEventListener("beforeunload",()=>{
      sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })*/
  },
  mounted() {},
  components: {},
};
</script>

<style type="text/css">
@import "common/css/common.css";

.el-popper{
  z-index: 999999!important;
}
</style>
